export enum PanelContext {
    primary = 'primary',
    primary_ghost = 'primary_ghost',
    info_ghost = 'info_ghost',
    danger_ghost = 'danger_ghost',
    plain = 'plain',
}
